export default __webpack_public_path__ + "static/media/migraçãoSegura-invert.19dc0066.png";